import { lookups, t } from '../../content';

const GROUP_KEYS = {
  All: 'analytics.groups.all',
  Interactive: 'analytics.groups.interactive',
  Operational: 'analytics.groups.operational',
  Intellectual: 'analytics.groups.intellectual',
  Emotional: 'analytics.groups.emotional',
  Objectives: 'analytics.groups.objectives',
  Relationships: 'analytics.groups.relationships',
  Environment: 'analytics.groups.environment',
  Competency: 'analytics.types.competency',
  Attitude: 'analytics.types.attitude',
};

function normalizeKey(value) {
  return String(value).toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]/g, '');
}

export function localizeGroupName(name) {
  const key = GROUP_KEYS[name];
  return key ? t(key) : name;
}

export function localizeSelectOptions(options = []) {
  return options.map((option) => {
    const groupName = option.id || option.title;
    return {
      ...option,
      id: groupName,
      title: localizeGroupName(groupName),
    };
  });
}

export function metricTitle(...keys) {
  const titles = lookups.metricTitles || {};
  for (const key of keys) {
    if (key == null || key === '') continue;
    const match = titles[key] || titles[String(key)] || titles[normalizeKey(key)];
    if (match) return match;
  }
  return keys.find((key) => key != null && key !== '') || '';
}

export function localizeMetricLabel(label) {
  if (label == null) return '';
  const key = Array.isArray(label) ? label.join(' ') : label;
  return metricTitle(key) || key;
}

export function localizeMetricLabels(labels = []) {
  return labels.map(localizeMetricLabel);
}

export function localizeColumn(column) {
  if (!column) return column;
  return {
    ...column,
    header_name: metricTitle(column.column_name, column.header_name, column.column_id) || column.header_name,
  };
}

export function localizeColumns(columns = []) {
  return columns.map(localizeColumn);
}
